import type { ReactNode } from 'react'
import { Press, type PressOwnProps } from './Press'
import { cx } from './cx'

/** Кнопка прототипа: основная — заливка брендом, ghost — приглушённая. */
export type ButtonVariant = 'primary' | 'ghost'

export interface ButtonOwnProps extends Omit<PressOwnProps, 'squish'> {
  variant?: ButtonVariant
  /** Компактная кнопка в шапке и в рядах. */
  small?: boolean
  /** Блокирует кнопку, крутит спиннер и помечает её занятой для диктора. */
  loading?: boolean
  children?: ReactNode
}

export type ButtonProps = ButtonOwnProps & Record<string, unknown>

export function Button({
  variant = 'primary',
  small = false,
  loading = false,
  disabled = false,
  className,
  children,
  ...rest
}: ButtonProps) {
  return (
    <Press
      squish="card"
      className={cx('btn', variant === 'ghost' && 'ghost', small && 'small', className)}
      disabled={disabled || loading}
      aria-busy={loading}
      {...rest}
    >
      {loading ? <span className="btn-spin" aria-hidden="true" /> : null}
      {children}
    </Press>
  )
}
